import { PulsingDot } from '@design-system';
import classNames from 'classnames';
import { FC } from 'react';

interface Props {
  active: boolean;
  className?: string;
  description?: string;
  title: string;
}

export const PreOrderHeader: FC<Props> = ({
  active,
  className = '',
  description,
  title,
}) => (
  <div className={`flex flex-col items-center gap-3 text-center ${className}`}>
    <p
      className={classNames(
        'flex items-center',
        active ? 'text-neutral-6' : 'text-neutral-4',
      )}
    >
      {active ? (
        <>
          <PulsingDot /> {title}
        </>
      ) : (
        title
      )}
    </p>
    {description && <p className="text-neutral-4">{description}</p>}
  </div>
);
